import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import { categories } from "../../data/categories"

export default function CategoriesPreview() {
  const featuredCategories = categories.slice(0, 6)

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">

        {/* Titre */}
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="text-blue-600 font-semibold uppercase tracking-wider">
            Nos Catégories
          </span>

          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-gray-900">
            Découvrez notre univers textile
          </h2>

          <p className="mt-4 text-gray-600 leading-relaxed">
            Explorez nos différentes catégories de produits destinés
            aux professionnels du textile, de la confection et de la mercerie.
          </p>
        </div>

        {/* Grille */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">

          {featuredCategories.map((category, index) => (
            <motion.div
              key={category.id}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.5,
                delay: index * 0.1,
              }}
            >
              <Link
                to={`/categories/${category.slug}`}
                className="group block bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
              >
                {/* Image */}
                <div className="overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-64 object-cover group-hover:scale-105 transition duration-500"
                    loading="lazy"
                  />
                </div>

                {/* Contenu */}
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 group-hover:text-blue-600 transition">
                    {category.name}
                  </h3>

                  <p className="mt-2 text-gray-600 text-sm">
                    Découvrir les produits disponibles.
                  </p>
                </div>
              </Link>
            </motion.div>
          ))}

        </div>

        {/* Bouton */}
        <div className="text-center mt-12">
          <Link
            to="/categories"
            className="inline-flex items-center justify-center px-8 py-4 bg-gray-900 hover:bg-black text-white font-semibold rounded-xl transition"
          >
            Voir toutes les catégories
          </Link>
        </div>

      </div>
    </section>
  )
}